import { render, staticRenderFns } from "./CompanyFeatureSetupForm.vue?vue&type=template&id=34ea7190&scoped=true&"
import script from "./CompanyFeatureSetupForm.vue?vue&type=script&lang=js&"
export * from "./CompanyFeatureSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea7190",
  null
  
)

export default component.exports